import type { ImageType } from './request_images'

// Detections carry no image byte-size metadata, so the Retrieve modal can only show a rough
// estimate. These are ballpark averages per artifact type (full-res render is the heaviest,
// the plate crop the lightest) — tune them as real transfer numbers come in.
export const AVG_BYTES_PER_TYPE: Record<ImageType, number> = {
    render: 300_000,
    roi: 120_000,
    lp: 25_000
}

// Estimated bytes for retrieving `types` across `count` detections: every detection is assumed
// to contribute one artifact of each selected type.
export const estimateTransferBytes = (count: number, types: ImageType[]): number =>
    types.reduce((sum, type) => sum + AVG_BYTES_PER_TYPE[type], 0) * Math.max(0, count)

const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const

// Human-readable size, one decimal from KB up (e.g. "12.5 MB", "950 B").
export const formatBytes = (bytes: number): string => {
    if (bytes <= 0) return '0 B'
    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1)
    const value = bytes / 1024 ** exponent
    return `${exponent === 0 ? Math.round(value) : value.toFixed(1)} ${UNITS[exponent]}`
}
